var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDermatology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.855,16.368h-8.226 c0.072,0.32,0.115,0.646,0.129,0.969c0.048,1.061-0.509,2.272-1.247,3.01c-0.772,0.772-1.919,1.247-3.01,1.247 c-1.153,0-2.177-0.482-3.01-1.247c-0.836-0.767-1.198-1.909-1.247-3.01c-0.014-0.315,0.026-0.644,0.108-0.969H3.46 c-0.433,0-0.783,0.351-0.783,0.783v9.518c0,0.433,0.351,0.783,0.783,0.783h24.395c0.433,0,0.783-0.351,0.783-0.783v-9.518 C28.639,16.718,28.288,16.368,27.855,16.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M5.984,19.753l-1.029-1.129 c-0.189-0.208-0.174-0.53,0.033-0.719l0,0c0.208-0.189,0.53-0.174,0.719,0.033l1.029,1.129c0.189,0.208,0.174,0.53-0.033,0.719l0,0 C6.496,19.975,6.174,19.96,5.984,19.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.759,19.315l0.849-1.27 c0.156-0.234,0.472-0.297,0.706-0.141l0,0c0.234,0.156,0.297,0.472,0.141,0.706l-0.849,1.27c-0.156,0.234-0.472,0.297-0.706,0.141 l0,0C8.665,19.865,8.602,19.549,8.759,19.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M3.701,21.912l1.36-0.695 c0.25-0.128,0.557-0.029,0.685,0.222l0,0c0.128,0.25,0.029,0.557-0.221,0.685l-1.36,0.696c-0.25,0.128-0.557,0.029-0.685-0.222l0,0 C3.351,22.347,3.45,22.04,3.701,21.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.851,22.731l-0.506-1.441 c-0.093-0.265,0.047-0.556,0.312-0.649l0,0c0.265-0.093,0.556,0.047,0.649,0.312l0.506,1.441c0.093,0.265-0.047,0.556-0.312,0.649 l0,0C8.235,23.136,7.944,22.996,7.851,22.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.217,26.137l-0.872-1.254 c-0.161-0.231-0.104-0.548,0.127-0.709l0,0c0.231-0.161,0.548-0.104,0.709,0.127l0.872,1.254c0.161,0.231,0.104,0.548-0.127,0.709 l0,0C6.695,26.425,6.377,26.368,6.217,26.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.022,24.897l-1.323,0.764 c-0.244,0.141-0.555,0.057-0.696-0.186l0,0c-0.141-0.244-0.057-0.555,0.186-0.696l1.323-0.764c0.244-0.141,0.555-0.057,0.696,0.186 l0,0C11.349,24.445,11.265,24.756,11.022,24.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.048,23.006l-1.08-1.08 c-0.199-0.199-0.199-0.521,0-0.72l0,0c0.199-0.199,0.521-0.199,0.72,0l1.08,1.08c0.199,0.199,0.199,0.521,0,0.72l0,0 C12.57,23.205,12.247,23.205,12.048,23.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M25.152,19.899l1.029-1.129 c0.189-0.208,0.174-0.53-0.033-0.719l0,0c-0.208-0.189-0.53-0.174-0.719,0.033l-1.029,1.129c-0.189,0.208-0.174,0.53,0.033,0.719 l0,0C24.641,20.122,24.963,20.107,25.152,19.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.378,19.462l-0.848-1.27 c-0.156-0.234-0.472-0.297-0.706-0.141l0,0c-0.234,0.156-0.297,0.472-0.141,0.706l0.848,1.27c0.156,0.234,0.472,0.297,0.706,0.141 l0,0C22.471,20.012,22.534,19.695,22.378,19.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.436,22.059l-1.36-0.696 c-0.25-0.128-0.557-0.029-0.685,0.222v0c-0.128,0.25-0.029,0.557,0.222,0.685l1.36,0.696c0.25,0.128,0.557,0.029,0.685-0.222l0,0 C27.785,22.494,27.686,22.187,27.436,22.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.285,22.878l0.506-1.441 c0.093-0.265-0.046-0.556-0.312-0.649l0,0c-0.265-0.093-0.556,0.046-0.649,0.312l-0.506,1.441 c-0.093,0.265,0.046,0.556,0.312,0.649l0,0C22.902,23.283,23.192,23.143,23.285,22.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.92,26.284l0.872-1.254 c0.16-0.231,0.104-0.548-0.127-0.709l0,0c-0.231-0.161-0.548-0.104-0.709,0.127l-0.872,1.254c-0.161,0.231-0.104,0.548,0.127,0.709 l0,0C24.442,26.572,24.759,26.515,24.92,26.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.115,25.044l1.323,0.764 c0.244,0.141,0.555,0.057,0.696-0.186l0,0c0.141-0.244,0.057-0.555-0.186-0.696l-1.323-0.764c-0.243-0.141-0.555-0.057-0.695,0.186 l0,0C19.788,24.592,19.871,24.903,20.115,25.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.707,25.69l1.323,0.764 c0.243,0.141,0.555,0.057,0.696-0.186l0,0c0.141-0.244,0.057-0.555-0.186-0.696l-1.323-0.764c-0.244-0.141-0.555-0.057-0.696,0.186 l0,0C16.38,25.238,16.463,25.549,16.707,25.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.088,23.153l1.08-1.08 c0.199-0.199,0.199-0.521,0-0.72l0,0c-0.199-0.199-0.521-0.199-0.72,0l-1.08,1.08c-0.199,0.199-0.199,0.521,0,0.72l0,0 C18.567,23.352,18.889,23.352,19.088,23.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.212,25.062l1.08-1.08 c0.199-0.199,0.199-0.521,0-0.72l0,0c-0.199-0.199-0.521-0.199-0.72,0l-1.08,1.08c-0.199,0.199-0.199,0.521,0,0.72l0,0 C13.691,25.261,14.013,25.261,14.212,25.062z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M30.247,16.662c0,2.256-1.829,4.084-4.084,4.084c-2.256,0-4.084-1.829-4.084-4.084 s1.829-4.084,4.084-4.084C28.419,12.578,30.247,14.406,30.247,16.662z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "28.928,15.497 27.31,15.497  27.31,13.879 25.088,13.879 25.088,15.497 23.47,15.497 23.47,17.719 25.088,17.719 25.088,19.337 27.31,19.337 27.31,17.719  28.928,17.719  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.104,14.576 C13.837,4.782,5.842,2.905,5.842,2.905c8.354,6.364,7.675,11.181,7.417,12.183c-0.495,0.54-0.805,1.253-0.805,2.043 c0,1.674,1.357,3.031,3.032,3.031c1.674,0,3.032-1.357,3.032-3.031C18.517,16.054,17.951,15.114,17.104,14.576z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDermatology);
export default __webpack_public_path__ + "static/media/dermatology.3a256a2aed6df5eedea8aa9946aa25ea.svg";
export { ForwardRef as ReactComponent };